// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import { mergeQuery } from 'modules/history/actions';

// Actions
import * as Filter from 'modules/filters/store/actions';

// Components
import FilterForm from 'components/filters/filter-form';


class FilterTab extends React.Component {
  static propTypes = {
    config: PropTypes.object,
    form: PropTypes.object,
    route: PropTypes.object,
    query: PropTypes.object,
    className: PropTypes.string,
    currentValues: PropTypes.object
  };

  constructor() {
    super();
    this.search = this.search.bind(this);
    this.applyFilterForm = this.applyFilterForm.bind(this);
    this.initializeFilters = this.initializeFilters.bind(this);
  }

  componentWillMount() {
    this.initializeFilters(this.props, true);
  }

  componentWillReceiveProps(nextProps) {
    this.initializeFilters(nextProps);
  }

  initializeFilters(props, mounting) {
    const { query, config } = props;
    const defaults = _.isFunction(config.defaults) ? config.defaults() : config.defaults;
    const settingDefault = (_.isEmpty(query) && !_.isEmpty(defaults)) || (query && query.setDefaultQuery);

    // Trigger setting defaults
    if (settingDefault) Filter.setDefaultQuery(defaults);

    // Trigger applying filters if we are configuring
    // and not setting defaults
    if (!settingDefault && mounting) mergeQuery({ where: props.query.where });
  }

  applyFilterForm() {
    // For some reason (see this possibly-related issue: https://github.com/erikras/redux-form/issues/2449)
    // redux-forms is passing the last-initialized values into onSubmit, which means if you use the values
    // passed into this function, rather than this.props.currentValues (then to repro: use the clear filters
    // button, then change something about your filters before submitting), this function will receive an empty
    // object and the filters will revert to being fully cleared
    mergeQuery({ where: _.pickBy(this.props.currentValues, _.identity), page: 1 });
  }

  search(e) {
    const search = e.target.value;
    const currentWhere = _.get(this.props, 'query.where', {});
    const where = search ? _.defaults({ search }, currentWhere) : _.omit(currentWhere, ['search']);

    mergeQuery({ where });
  }

  render() {
    const { config, route, currentValues, ...props } = this.props;
    const initialValues = route.query && route.query.where;
    const noFilters = _.isEmpty(config.basic) && _.isEmpty(config.advanced);

    if (noFilters) return null;

    return (
      <div className={`filter-tab ${this.props.className}`}>
        <FilterForm
          {...props}
          config={config}
          initialValues={initialValues}
          currentValues={currentValues}
          onSubmit={this.applyFilterForm}
          withRef
          ref={(el) => { this.form = el; }}
        />
      </div>
    );
  }
}

// Internal methods
function mapStateToProps(state) {
  return {
    // config: state.filters.config,
    route: state.location,
    query: state.location.query,
    currentValues: getFormValues('filterForm')(state)
  };
}

// Exports
export default connect(mapStateToProps)(FilterTab);
